export default "__VITE_ASSET__3d19dca5__"